//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ReagentDilutionDrawer from "./modules/ReagentDilutionDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryUserTreeList as _queryUserTreeList } from '@/api/api';
export default {
  name: 'ReagentDilutionList',
  mixins: [JeecgListMixin],
  components: {
    ReagentDilutionDrawer: ReagentDilutionDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/reagent/dilution',
      pageTitle: '标液稀释',
      userTree: [],
      // 表头
      // 表头
      isorter: {
        column: 'dilution_time',
        order: 'desc'
      },
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, // {
      //   dataIndex: 'name',
      //   colName: 'name',
      //   title: '试剂名称',
      //   align: 'center',
      //   sorter: true
      // },
      {
        dataIndex: 'productName',
        colName: 'product_id',
        title: '标准物质',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'concentration',
        colName: 'concentration',
        title: '稀释后浓度',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '保管站点',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'motherLiquor',
        colName: 'mother_liquor',
        title: '母液体积',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'meteredVolume',
        colName: 'metered_volume',
        title: '定容体积',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '配制人员',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'dilutionTime',
        colName: 'dilution_time',
        title: '配制时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'effectiveTime',
        colName: 'effective_time',
        title: '有效时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'status_dictText',
        colName: 'status',
        title: '状态',
        align: 'center',
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {
    this.queryUserTreeList();
  },
  computed: {},
  methods: {
    queryUserTreeList: function queryUserTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      _queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    onDateDilutionTime: function onDateDilutionTime(value, dateArray) {
      this.queryParam.dilutionTimeStart = dateArray[0];
      this.queryParam.dilutionTimeEnd = dateArray[1];
    },
    onDateEffectiveTime: function onDateEffectiveTime(value, dateArray) {
      this.queryParam.effectiveTimeStart = dateArray[0];
      this.queryParam.effectiveTimeEnd = dateArray[1];
    }
  }
};